import { fetchApi } from "../fetchInstance";
import {
  getBookListUrl,
  getBookUrl,
  getBookMemoriesUrl,
  getCreateBookUrl,
  getCreateSubmissionUrl,
  getMemoriesOfABookUrl,
  getSubmissionUrl,
  getUpdateBookUrl,
  getOrderMemoriesUrl,
  downloadBookSubmissionUrl,
  downloadBookUrl,
} from "./url";
/**
 * @typedef {{pageIndex:number,pageSize:number,orderBy:'createdDate'|'title'|'updatedDate'}} FetchMemoryDto
 */

/**
 * @typedef {{
 *  title:string,
 *  memoryID:string[],
 *  firstName?:string,
 *  lastName?:string,
 *  subtitle?:string,
 *  dedication?:string,
 *  photoLayout?:string,
 *  addOns?:string[],
 *  frontCoverStyle?:string,
 *  frontCoverColor?:string,
 *  backCoverStyle?:string,
 *  backCoverColor?:string,
 *  signal?:any
 * }} CreateBookDto
 */

/**
 * @typedef {Omit<CreateBookDto, "signal"> & {consentText:string}} CreateSubmissionDto
 */

const bookApi = {
  getBookList: () => {
    return fetchApi.get(getBookListUrl);
  },

  /**
   * @param {AbortSignal} [signal]
   */
  getBook: (signal) => {
    return fetchApi.get(getBookUrl, undefined, signal);
  },

  /**
   * @param {string} [bookId]
   * @param {AbortSignal} [signal]
   */
  getBookMemories: (bookId, signal) => {
    return fetchApi.get(getBookMemoriesUrl(bookId), undefined, signal);
  },

  /**
   *
   * @param {CreateBookDto} obj
   */
  createABook: (obj) => {
    const { signal, ...rest } = obj;
    return fetchApi.post(getCreateBookUrl, rest, undefined, signal);
  },

  /**
   * @param {string} bookID
   */
  getMemoriesOfABook: (bookID) => {
    return fetchApi.get(getMemoriesOfABookUrl(bookID));
  },

  /**
   * @param {CreateBookDto} obj
   */
  updateBookMemories: (bookID, obj) => {
    return fetchApi.patch(getUpdateBookUrl(bookID), obj);
  },

  /**
   * @param {string} bookID
   * @param {Omit<CreateBookDto, "memoryID"|"signal">} obj
   */
  updateABook: (bookID, obj) => {
    return fetchApi.put(getUpdateBookUrl(bookID), obj);
  },

  /**
   * @param {string} bookID
   */
  downloadBook: (bookID) => fetchApi.post(downloadBookUrl(bookID), {}),

  /**
   * Upserts the user's book and creates a submission (with consent) in one call.
   * @param {CreateSubmissionDto} obj
   */
  createSubmission: (obj) => {
    return fetchApi.post(getCreateSubmissionUrl, obj);
  },
};

export default bookApi;

export const bookAdminApi = {
  /**
   *
   * @param {number} pageIndex
   */
  getSubmission(pageIndex, signal) {
    return fetchApi.get(getSubmissionUrl(pageIndex), undefined, signal);
  },

  getOrderMemories({ orderID, pageIndex, signal, orderBy }) {
    return fetchApi.get(
      getOrderMemoriesUrl({ orderID, pageIndex, orderBy }),
      undefined,
      signal,
    );
  },

  resubmitBook({ orderID, signal }) {
    return fetchApi.get(downloadBookSubmissionUrl(orderID), undefined, signal);
  },
};
